import { environment } from 'environments/environment';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, HostListener, TemplateRef, DoCheck, Inject } from '@angular/core';
import { LoginService } from '@app/services/login.service';
import { Menu } from '@app/models/util/menu';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { Processo, ProcessoConsulta } from '@app/models/processo.model';
import { BuscarProcessosComponent } from '@app/pages/processos/buscar-processos/buscar-processos.component';
import { BuscarProcessosModel } from '@app/pages/processos/buscar-processos/model';
import { ProcessoService } from '@app/services/processo.service';
import { Paginacao } from '@app/models/util/paginacao';
@Component({
  selector: 'app-dashboard',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, DoCheck {
  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };
  funcionario: string;
  producao: boolean;
  buscarProcessosModel = new BuscarProcessosModel();
  menusMap: Map<string, MenuGrupoDados> = new Map<string, MenuGrupoDados>();
  filtroDescricao: string = '';

  mobileX: boolean = true;
  contagem = 0;
  loginRapido = false;
  login = '';
  senha = '';
  carregando = false;

  filtroCampo = '';
  clienteId = '';
  loading = true;
  _descricao = '';
  _pagina = 1;

  mostrarTabela: boolean = true; 
  botaoDesabilitado: boolean = false;

  modalAtalhos: BsModalRef;
  modalLoginRapido: BsModalRef;
  listaProcessosEncerradosOuInativos: ProcessoConsulta[] = [];
  listaProcessosAtivos: ProcessoConsulta[] = [];

  paginacao: Paginacao = new Paginacao();
  pesquisaPorClienteId: boolean = false;

  @ViewChild('loginRapido', { static: true }) loginRapidoRef: TemplateRef<any>;
  @ViewChild('btnToggle', { static: true }) btnToggle: ElementRef;
  pesquisandoArquivados: boolean;
  pesquisando: boolean;

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const tabela = document.querySelector('.dropdown-table');

    if (tabela && !tabela.contains(target)) {
      this.ocultarTabela();
    }
  }

  @HostListener('document:keydown', ['$event'])
  atalhoGravar(event: KeyboardEvent) {
    if (event.ctrlKey) {
      switch (event.key) {  
        case 'a' || 'A':
          event.preventDefault();
          this.router.navigate([`./agenda/minha-agenda`]);
          break;
        case 'b' || 'B':
          event.preventDefault();
          this.router.navigate([`./processos/buscar-processos`]);
          break;
        case 'i' || 'I':
          if (event.altKey) {
            event.preventDefault();
            this.router.navigate([`./processos/importacao-publicacao`]);
          }
          else {
            event.preventDefault();
            this.router.navigate([`./dashboard`]);
          }
          break;
        case 'l' || 'L':
          event.preventDefault();
          this.router.navigate([`./financeiro/lancamento`]);
          break;
        case 'Enter':
          event.preventDefault();
          if (document.getElementById('pesquisar') !== null) {
            document.getElementById('pesquisar').click();
          } else {
            this.toastr.warning('Pesquisar não encontrado');
          }

          break;
        default:
          break;
      }
    }
  }

  constructor(
    private loginService: LoginService,
    public router: Router,
    private route: ActivatedRoute,
    private processoService: ProcessoService,
    private usuarioTipoService: UsuarioTipoService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private observer: BreakpointObserver,
  ) {
    this.observer.observe('(max-width: 390px)').subscribe((result: BreakpointState) => {
      if (result.matches) {
        this._naoAplicaResponsividadeMobile()
      } else {
        this._aplicaResponsividadeMobile()
      }
    });

    if (environment.PRODUCAO) {
      this.producao = true;
    };

  }

  abrirProcesso(processo: ProcessoConsulta) {
    this.router.navigate(['/processos/processo', processo.Id]); 
    this.ocultarTabela(); 
  }

  ocultarTabela() {
    this.mostrarTabela = false;
  }

  ngOnInit(): void {
    this.funcionario = this.loginService.obterFuncionario();
    this.preencheMenu();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.includes('/processos/buscar-processos')) {
          this.botaoDesabilitado = true;
        }
        else
          this.botaoDesabilitado = false;
      }
    });

    //necessário em caso de reload do navegador
    this.botaoDesabilitado = this.router.url.includes('/processos/buscar-processos');

}

onKeyPress(event: KeyboardEvent) {
  this.mostrarTabela = true;
  this.buscarProcessosModel.FiltroDescricao = this.filtroDescricao;

  if (this.buscarProcessosModel.FiltroDescricao.length >= 3 || this.buscarProcessosModel.FiltroDescricao.length == 0) {
    this.obterTodos(this.filtroDescricao, 1);
  }
}

obterTodos(descricao: string, pagina: number) {
  this.buscarProcessosModel.FiltroDescricao = '';
  if (this.pesquisaPorClienteId) {
    descricao = this.clienteId;
    this.buscarProcessosModel.FiltroCampo = 'clienteId';
  }

  this._descricao = descricao;
  this.buscarProcessosModel.FiltroDescricao = descricao;
  this._pagina = pagina;
  this.buscarProcessosModel.Pagina = pagina;

    this.processoService.obterBusca(this.buscarProcessosModel).subscribe(
      data => {    
        this.listaProcessosAtivos = data.Dados;
        this.loading = false;
      },
      erro => {
        console.error("Erro na requisição:", erro);
        this.loading = false;
      }
    );
}

  ngDoCheck() {
    this.loginRapido = localStorage.getItem('Login.Rapido') === '1';
    if (this.loginRapido && this.contagem === 0) {
      this.toastr.info('Sua sessão expirou');
      this.modalLoginRapido = this.modalService.show(this.loginRapidoRef, {
        keyboard: false,
        ignoreBackdropClick: true
      });
      this.contagem++;
    }
  }

  submitLoginRapido() {
    this.carregando = true;
    this.loginService.login(this.login, this.senha).subscribe((data: any) => {
      localStorage.setItem('Cardeal.Token', data.AccessToken);
      localStorage.setItem('Cardeal.Usuario', JSON.stringify(data.NomeUsuario));
      localStorage.setItem('Login.Rapido', '0');
      this.modalLoginRapido.hide();
      this.carregando = false;
      this.contagem = 0;
    },
      (error: any) => {
        this.toastr.error('Login inválido');
        this.carregando = false;
      });
  }

  sair() {
    localStorage.removeItem('Cardeal.Token');
    localStorage.removeItem('Cardeal.Usuario');
    this.router.navigate(['/login']);
  }

  preencheMenu(): void {
    this.usuarioTipoService.obterOpcoesDeMenu(-1, false).toPromise()
      .then(data => {
        let menus: Menu[] = [];
        menus = data;
        menus = menus.filter(x => x.Selecionado);

        menus.forEach(menu => {
          if (menu.SubMenu != null) {
            menu.SubMenu = menu.SubMenu.filter(x => x.Selecionado);
          }
        });

        this._construirMenus(menus);
      }
    );
  }

  private _construirMenus(menus: Menu[]) {
    this.menusMap.set("1", new MenuGrupoDados(
      'Cadastros', 'fa fa-group', menus.filter(x => x.LocalDoMenu === 0))
    );
    this.menusMap.set("2", new MenuGrupoDados(
      'Processos', 'fa fa-gavel', menus.filter(x => x.LocalDoMenu === 1))
    );
    this.menusMap.set("3", new MenuGrupoDados(
      'Agenda', 'fa fa-calendar', menus.filter(x => x.LocalDoMenu === 2))
    );
    this.menusMap.set("4", new MenuGrupoDados(
      'Financeiro', 'fa fa-usd', menus.filter(x => x.LocalDoMenu === 3))
    );
    this.menusMap.set("5", new MenuGrupoDados(
      'Petição', 'fa fa-file-text-o', menus.filter(x => x.LocalDoMenu === 4))
    );

    this._adicionaMenuRelatorios(menus.filter(x => x.LocalDoMenu === 5));
    this._adicionaMenuConfiguracoes(menus.filter(x => x.LocalDoMenu === 6));
  }

  private _adicionaMenuRelatorios(menuRelatorio: Menu[]) {
    let possuiRelatorio = menuRelatorio.some(x => x.SubMenu.length !== 0);

    if (possuiRelatorio) {
      this.menusMap.set("6", new MenuGrupoDados(
          'Relatórios',
          'fa fa-files-o',
          menuRelatorio.filter(x => x.SubMenu.length !== 0)
        )
      );
    }
  }

  private _adicionaMenuConfiguracoes(menuConfiguracoes: Menu[]) {
    let possuiConfigs = menuConfiguracoes.some(x => x.SubMenu.length !== 0);
    
    if (possuiConfigs) {
      this.menusMap.set("7", new MenuGrupoDados(
          'Configurações',
          'fa fa-cog',
          menuConfiguracoes.filter(x => x.SubMenu.length !== 0)
        )
      );
    }
  }

  abrirModalAtalhos(modalReferencia: TemplateRef<any>) {
    this.modalAtalhos = this.modalService.show(modalReferencia);
  }

  fecharModalAtalhos() {
    this.modalAtalhos.hide();
  }

  voltar() {
    window.history.go(-1);
  }

  private _aplicaResponsividadeMobile() {
    this.mobileX = false;
  }
  private _naoAplicaResponsividadeMobile() {
    this.mobileX = true;
  }

  desabilitarBotao() {
    if(this.filtroDescricao.trim() != '') {
      this.botaoDesabilitado = true;
      localStorage.setItem('botaoDesabilitado', 'true');  
    }
  }
}

export class MenuGrupoDados {
  Menus: Menu[] = [];
  Descricao: string = '';
  Icone: string = '';

  constructor(descricao: string, icone: string, menus: Menu[]) {
    this.Menus = menus;
    this.Descricao = descricao;
    this.Icone = icone;
  }
}